import { faSearchLocation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import { FormCircularProgress } from '../common/forms/FormElements';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import ArcGisLocationDisplay from '../lowboyDispatch/ArcGisLocationDisplay';
import FaqtsLocationDisplay from '../lowboyDispatch/FaqtsLocationDisplay';

export default class EquipmentLocationHistoryButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            equipmentLocations: [],
            showModal: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    fetchLocationData = async () => {
        const { equipment } = this.props;
        this.setState({ showModal: true, loading: true });

        const [equipmentLocations] = await Promise.all([
            util.fetch.andGetResponse(
                util.fetch.types.post,
                ApiRoutes.equipmentLocation.getFor(equipment.id)
            ),
        ]);

        this.setState({ equipmentLocations, loading: false });
    };

    render() {
        const { locationDataPresent } = this.props;
        const { showModal, loading, equipmentLocations } = this.state;

        return (
            <>
                <Button
                    disabled={!locationDataPresent}
                    color="success"
                    onClick={this.fetchLocationData}
                >
                    {locationDataPresent && (
                        <div>
                            <FontAwesomeIcon
                                icon={faSearchLocation}
                                className="mr-2"
                            />{' '}
                            View Location History
                        </div>
                    )}

                    {!locationDataPresent && <div>No Location History</div>}
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="xl">
                    <ModalHeader toggle={this.toggleModal}>
                        Location History
                    </ModalHeader>
                    <ModalBody>
                        {loading && <FormCircularProgress />}

                        {!loading && (
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Origin</th>
                                        <th>Destination</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {equipmentLocations.map((el) => {
                                        const displayDate = moment(
                                            el.moveRequestedFor
                                        ).format(
                                            MomentDateFormat.DateTimeShortAnte
                                        );

                                        const noOrigin =
                                            !el.originLocationId &&
                                            !el.originArcGisLocationId;

                                        return (
                                            <tr key={el.id}>
                                                <td>{displayDate}</td>
                                                <td>
                                                    {noOrigin && <>Untracked</>}

                                                    {origin &&
                                                        el.originArcGisLocation && (
                                                            <ArcGisLocationDisplay
                                                                location={
                                                                    el.originArcGisLocation
                                                                }
                                                            />
                                                        )}

                                                    {origin &&
                                                        el.originLocation && (
                                                            <FaqtsLocationDisplay
                                                                location={
                                                                    el.originLocation
                                                                }
                                                            />
                                                        )}
                                                </td>
                                                <td>
                                                    {el.destinationArcGisLocation && (
                                                        <ArcGisLocationDisplay
                                                            location={
                                                                el.destinationArcGisLocation
                                                            }
                                                        />
                                                    )}

                                                    {el.destinationLocation && (
                                                        <FaqtsLocationDisplay
                                                            location={
                                                                el.destinationLocation
                                                            }
                                                        />
                                                    )}

                                                    {!el.destinationArcGisLocation &&
                                                        !el.destinationLocation && (
                                                            <>Unknown</>
                                                        )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        )}
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
